import React from 'react';
import { useAppContext } from 'Context/ReactAppContext';
import { isFeatureFlipped } from 'Utils/feature-flipping/featureFlippingUtils';
export const useFeatureFlip = (key: string) => {
  const appContext = useAppContext();
  return isFeatureFlipped(appContext)(key);
};
